import {Component, Input} from '@angular/core';
import {SectionsContainer} from '../../core/definitions/sections-container';

@Component({
    selector: 'app-information-view-and-edit',
    templateUrl: './information-view-and-edit.component.html',
    styleUrls: ['./information-view-and-edit.component.scss'],
    standalone: false
})
export class InformationViewAndEditComponent {
  @Input() isEditing: boolean;
  @Input() sectionsContainer: SectionsContainer;
}
